import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import ListingSection from '../ListingSection';
import ListingSectionItem from '../ListingSectionItem';

/**
 * This component is used to render a skeleton loading state for the amenities section of the listing page.
 * @returns {React.JSX.Element}
 */

const SectionAmenitiesMaybeLoadingSkeleton = () => (
  <ListingSection>
    <ListingSectionItem>
      <Skeleton height="180px" sx={{ borderRadius: 2 }} variant="rounded" width="100%" />
    </ListingSectionItem>
  </ListingSection>
);

export default SectionAmenitiesMaybeLoadingSkeleton;